function CheckboxGroup({ label, options }) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="text-gray-600 font-medium">{label}</label>
      <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-2 w-full">
        {options.map((option, index) => (
          <div key={index} className="flex items-center gap-2 w-full">
            <input type="checkbox" className="w-5 h-5" />
            <span>{option}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CheckboxGroup;
